import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@examdojo/core/environment';
import escapeRegExp from 'lodash/escapeRegExp';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { SyllabusQuery } from '../syllabus/syllabus.query';
import { ApiHttpHeader } from './api-http-header.model';

@Injectable()
export class ApiHttpHeaderInterceptor implements HttpInterceptor {
  constructor(private readonly syllabusQuery: SyllabusQuery) {}

  private readonly whiteListUrls = [
    environment.examdojo.cmsApiUrl,
    environment.examdojo.examdojoApiUrl,
    environment.examdojo.studentsApiUrl,
    environment.examdojo.billingApiUrl,
  ];

  private readonly whiteListUrlsRegExps: RegExp[] = this.whiteListUrls
    .filter(Boolean)
    .map((url) => new RegExp(escapeRegExp(url)));

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.whiteListUrlsRegExps.some((url) => url.test(req.url))) {
      return next.handle(req);
    }

    return this.syllabusQuery.activeProgram$.pipe(
      take(1),
      map((program) => {
        if (!program?.code) {
          return req;
        }

        return req.clone({
          setHeaders: {
            [ApiHttpHeader.Program]: program.code,
          },
        });
      }),
      switchMap((request) => next.handle(request)),
    );
  }
}
